<template>
  <div>
    <v-card flat>
      <v-divider />
      <v-card-text>
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="meta.lokakarya_urutan"
          :total="Object.keys(meta.lokakarya_kegiatan || {}).length"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-google-classroom</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <p class="caption grey--text">
                            Nama Kegiatan
                          </p>
                          <span class="body-1"> {{ $getDeepObj(meta, `lokakarya_kegiatan.${item}.0`) || '-' }} </span>
                          <div v-if="isTutup(item)">
                            <small class="caption red--text">
                              Kegiatan Refleksi Coaching pada bulan ini ditiadakan, sehingga instrumen pelaporan ditutup
                            </small>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Periode Pelaksanaan</small></v-label>
                          </v-list-item-title>
                          <div class="link black--text body-2">
                            <span v-if="[38, 58].includes(+item)">
                              Mei - Juli 2023
                            </span>
                            <span v-else-if="[39].includes(+item)">
                              Juni - Juli 2023
                            </span>
                            <span v-else>
                              {{ $getDeepObj(meta, `lokakarya_kegiatan.${item}.1`) || '-' }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small> Status </small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-chip
                              dark
                              :color="
                                Number(data[item] && data[item]['is_lengkap']) === 1
                                  ? Number(data[item] && data[item]['is_terlaksana']) !== 1
                                    ? 'grey'
                                    : 'success'
                                  : 'orange'
                              "
                            >
                              {{
                                Number(data[item] && data[item]['is_lengkap']) === 1
                                  ? Number(data[item] && data[item]['is_terlaksana']) !== 1
                                    ? 'Tidak Memfasilitasi'
                                    : 'Sudah Lengkap'
                                  : 'Belum Lengkap'
                              }}
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Aksi</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <div>
                              <v-btn
                                :disabled="
                                  (Number($getDeepObj(item, 'is_lengkap')) !== 1 &&
                                    !$getDeepObj(meta, `lokakarya_kegiatan.${item}.2`)) ||
                                    !(meta.kp_pa || []).length ||
                                    isTutup(item)
                                "
                                small
                                color="primary"
                                @click="onEdit(item)"
                              >
                                <v-icon left>
                                  {{
                                    $getDeepObj(meta, `lokakarya_kegiatan.${item}.2`) &&
                                    !$getDeepObj(meta, `lokakarya_kegiatan.${item}.3`)
                                      ? 'mdi-eye'
                                      : 'mdi-pencil'
                                  }}
                                </v-icon>
                                {{
                                  $getDeepObj(meta, `lokakarya_kegiatan.${item}.2`) &&
                                  !$getDeepObj(meta, `lokakarya_kegiatan.${item}.3`)
                                    ? 'Lihat Detail'
                                    : 'Lengkapi'
                                }}
                              </v-btn>
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
    </v-card>
    <base-modal-full
      ref="modal"
      :useSave="formulir.useSave"
      :auto-close="formulir.component === 'FormKpPaLokakarya'"
      :title="formulir.title"
      @save="onSave"
      @close="onClose"
    >
      <component
        ref="formulir"
        :is="formulir.component"
        :initValue="formulir.init || {}"
        :kKegiatan="formulir.k_kegiatan || ''"
        :isEdit="formulir.isEdit"
        :readOnly="formulir.readOnly"
        :masters="masters"
        :detail="formulir.detail || {}"
        :meta="meta"
        @refresh="onRefresh"
      />
    </base-modal-full>
  </div>
</template>

<script>
import list from '@mixins/list';
import FormKpPaLokakarya from '../form/KpPaLokakarya';
import DetailLokakaryaRefleksi from '../form/DetailLokakaryaRefleksi';
import { mapActions, mapState } from 'vuex';
export default {
  components: { FormKpPaLokakarya, DetailLokakaryaRefleksi },
  mixins: [list],
  props: {
    gelombang: {
      default: 1,
    },
    tahun_ke: {
      default: 1,
    },
  },
  data() {
    return {
      endpoint: 'pendampingan-lokakarya',
      formulir: {},
      meta: {},
    };
  },
  computed: {
    ...mapState('master', ['masters']),
  },
  created() {
    const masters = ['lokakarya_moda_psp', 'kp_opsi_psp', 'propinsi', 'kota'].join(';');
    this.getMasters(masters);
  },
  methods: {
    ...mapActions('lokakaryaPa', ['fetch', 'update', 'getDetail', 'getInstrumen']),
    ...mapActions('master', ['getMasters']),

    isTutup(kLokakarya) {
      return [72, 96, 115].includes(+kLokakarya);
    },

    fetchData() {
      return new Promise((resolve) => {
        this.params.gelombang = this.gelombang;
        this.params.tahun_ke = this.tahun_ke;

        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const attr = Object.assign({}, this.attr);
        this.fetch({ params, attr }).then((resp) => {
          const data = resp?.data || [];
          this.data = {};
          for (const dt of data) {
            this.data[dt.k_lokakarya_kegiatan_psp] = dt;
          }
          this.meta = resp?.meta || {};

          const tahun_ke = [...[], ...(this.meta.tahun_ke || [])].pop();
          const mTahun = (this.meta.tahun_ke || []).reverse().map((tahun) => {
            return { text: `Tahun ke-${tahun}`, value: tahun };
          });

          this.$emit('config', { mTahun, tahun_ke });
          resolve(true);
        });
      });
    },

    async onRefresh() {
      const id = this.formulir.id;
      const kKegiatan = this.formulir.k_kegiatan;
      const data = await this.getDetail({ id, kKegiatan });

      this.$set(this.formulir, 'detail', data);
    },

    async onEdit(kKegiatan) {
      if ((this.meta['lokakarya_refleksi'] || []).includes(+kKegiatan)) {
        await this.onDetail(kKegiatan);
        return;
      }

      const readOnly = !this.$getDeepObj(this.meta, `lokakarya_kegiatan.${kKegiatan}.3`);
      const kpPas = this.meta.kp_pa || [];
      const id = kpPas[0] && kpPas[0]['psp_kp_pa_id'];

      this.$set(this.formulir, 'id', id);
      this.$set(this.formulir, 'k_kegiatan', kKegiatan);
      this.$set(this.formulir, 'init', null);

      let data = {};
      if (id && kKegiatan) {
        data = await this.getDetail({ id, kKegiatan });
      }

      let keyInstrumen = this.$getDeepObj(this.meta, `lokakarya_kegiatan.${kKegiatan}.5`);
      await this.getInstrumen({ masters: keyInstrumen });

      this.$set(this.formulir, 'title', 'Laporan Pendampingan Kelompok');
      this.$set(this.formulir, 'component', 'FormKpPaLokakarya');
      this.$set(this.formulir, 'isEdit', true);
      this.$set(this.formulir, 'detail', data);
      this.$set(this.formulir, 'useSave', !readOnly);
      this.$set(this.formulir, 'readOnly', readOnly);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', (data && data.lokakarya) || {});
      });
    },

    async onDetail(kKegiatan) {
      const readOnly = true;
      const kpPas = this.meta.kp_pa || [];
      const id = kpPas[0] && kpPas[0]['psp_kp_pa_id'];

      this.$set(this.formulir, 'id', id);
      this.$set(this.formulir, 'k_kegiatan', kKegiatan);
      this.$set(this.formulir, 'init', null);

      let data = {};
      if (id && kKegiatan) {
        data = await this.getDetail({ id, kKegiatan });
      }

      const isEdit = this.$getDeepObj(this.meta, `lokakarya_kegiatan.${kKegiatan}.3`);

      this.$set(this.formulir, 'title', 'Detail Laporan Refleksi Pendampingan Kelompok');
      this.$set(this.formulir, 'component', 'DetailLokakaryaRefleksi');
      this.$set(this.formulir, 'isEdit', isEdit);
      this.$set(this.formulir, 'detail', data);
      this.$set(this.formulir, 'useSave', !readOnly);
      this.$set(this.formulir, 'readOnly', readOnly);

      this.$refs.modal.open();
    },

    onSave() {
      const params = this.$refs.formulir.getValue();
      const id = this.formulir.id;

      this.update({ id: id, params: params })
        .then(() => {
          this.$success(`Laporan pendampingan kelompok berhasil diperbarui`);
          this.onReload();
          this.onRefresh();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onDelete(item) {
      this.$confirm('Apakah anda yakin ingin menghapus data berikut ?', `Peringatan`, {
        tipe: 'error',
      }).then(() => {
        this.delete({ id: this.$getDeepObj(item, 'psp_kp_lokakarya_id') }).then(() => {
          this.$success('Data kelompok berhasil di hapus');
          this.onReload();
        });
      });
    },

    onClose() {
      this.onReload();
    },
  },
};
</script>

<style scoped></style>
